export const lpImages = {
  logoImage: {
    src: 'https://www.datocms-assets.com/23496/1700835210-ls_logo_black_2022.svg?auto=format&fit=crop&fp-x=0.51&fp-y=0.51',
    width: 100,
    height: 20,
  },
  heroImage: {
    src: 'https://www.datocms-assets.com/23496/1701356321-gettyimages-1062517720_16-9-1-1.png?auto=format&fit=crop&fp-x=0.51&fp-y=0.51',
    width: 620,
    height: 464,
    bgColor: '#c49879',
  },
  pearIcon: {
    src: 'https://www.datocms-assets.com/23496/1700646675-pear-2.png?auto=format',
    width: 35,
    height: 42,
  },
  howItWorksImage: {
    src: 'https://www.datocms-assets.com/23496/1700662233-how-it-works.png?auto=format',
    width: 619,
    height: 691,
  },
  howItWorksImage1: {
    src: 'https://www.datocms-assets.com/23496/1700662597-rectangle-2.png?auto=format',
    width: 574,
    height: 300,
  },
  testimonialImage: {
    src: 'https://www.datocms-assets.com/23496/1701901033-image-53.png?auto=format',
    width: 620,
    height: 466,
  },
  testimonialCover: {
    src: 'https://www.datocms-assets.com/23496/1701357182-frame-7373-1-edited.png?auto=forma',
    width: 411,
    height: 633,
  },
  infoSectionImage: {
    src: 'https://www.datocms-assets.com/23496/1701901105-image-52.png?auto=format&fit=crop&fp-x=0.51&fp-y=0.21',
    width: 620,
    height: 414,
  },
  mealPlanImage1: {
    src: 'https://www.datocms-assets.com/23496/1700759017-mealplan-climaterian.png?auto=format&fit=crop&fp-x=0.51&fp-y=0.21',
    width: 290,
    height: 209,
  },
  mealPlanImage2: {
    src: 'https://www.datocms-assets.com/23496/1700759002-mealplan-climaterian-1.png?auto=format&fit=crop&fp-x=0.51&fp-y=0.21',
    width: 290,
    height: 209,
  },
  mealPlanImage3: {
    src: 'https://www.datocms-assets.com/23496/1700759011-mealplan-climaterian-2.png?auto=format&fit=crop&fp-x=0.51&fp-y=0.21',
    width: 290,
    height: 209,
  },
  mealPlanImage4: {
    src: 'https://www.datocms-assets.com/23496/1700759040-mealplan-climaterian-3.png?auto=format&fit=crop&fp-x=0.51&fp-y=0.21',
    width: 290,
    height: 209,
  },
  checkIcon: {
    src: 'https://www.datocms-assets.com/23496/1700766690-checkmark.png?auto=format',
    width: 24,
    height: 24,
  },
  starIcon: {
    src: 'https://www.datocms-assets.com/23496/1701092834-star-solid.svg?auto=format',
    width: 16,
    height: 16,
  },
  iphoneIcon: {
    src: 'https://www.datocms-assets.com/23496/1701094890-frame-7358.svg?auto=format',
    width: 24,
    height: 24,
  },
  androidIcon: {
    src: 'https://www.datocms-assets.com/23496/1701094898-frame-7357.png?auto=format',
    width: 24,
    height: 24,
  },
  cardImage1: {
    src: 'https://www.datocms-assets.com/23496/1701356931-mixed-fish-veggie.png?auto=format',
    width: 218,
    height: 213,
  },
  cardImage2: {
    src: 'https://www.datocms-assets.com/23496/1701167873-frame-7445.png?auto=format',
    width: 338,
    height: 213,
  },
  cardImage3: {
    src: 'https://www.datocms-assets.com/23496/1701168658-frame-7383.png?auto=format',
    width: 278,
    height: 213,
  },
  cardImage4: {
    src: 'https://www.datocms-assets.com/23496/1701105095-pear-with-hearts.png?auto=format',
    width: 254,
    height: 213,
  },
  cardImage5: {
    src: 'https://www.datocms-assets.com/23496/1701105103-mixed-fruit-meals.png?auto=format',
    width: 167,
    height: 213,
  },
  faqImage: {
    src: 'https://www.datocms-assets.com/23496/1701176750-woman-celebrating-1.png?auto=format',
    width: 730,
    height: 775,
  },
  faqImageMobile: {
    src: 'https://www.datocms-assets.com/23496/1701617697-woman-celebrating-1.png?auto=format',
    width: 390,
    height: 414,
  },
  chevronIcon: {
    src: 'https://www.datocms-assets.com/23496/1701179744-chevron-right-2.svg?auto=format',
    width: 24,
    height: 24,
  },
  infoSectionImage2: {
    src: 'https://www.datocms-assets.com/23496/1701187072-rayul-8sgqm_f0m_i-unsplash-1.png?auto=format',
    width: 510,
    height: 638,
  },
  closeIcon: {
    src: 'https://www.datocms-assets.com/23496/1701339134-close.svg?auto=format',
    width: 24,
    height: 24,
  },
  qrCode: {
    src: 'https://www.datocms-assets.com/23496/1702641804-conversionistalandingpagegeneral.png',
    width: 350,
    height: 350,
  },
  appStoreImage: {
    src: 'https://www.datocms-assets.com/23496/1701342269-image-2.png?auto=format',
    width: 120,
    height: 40,
  },
  googlePlayImage: {
    src: 'https://www.datocms-assets.com/23496/1701342276-image-3.png?auto=format',
    width: 134,
    height: 40,
  },
  testimonial1: {
    src: 'https://www.datocms-assets.com/23496/1702136962-image-1457-2-edited.png?auto=format',
    width: 333,
    height: 350,
  },
  testimonial2: {
    src: 'https://www.datocms-assets.com/23496/1702136523-testimonal-bjarne-1.png?auto=format',
    width: 333,
    height: 350,
  },
}
